/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { css, StyleSheet } from 'aphrodite';
import React, { useState } from 'react';

import { ActionButton } from '@blend/enterprise-components';
import { TabSectionHeader } from '../../OverviewTab/TabSectionHeader';
import { NotesList } from '../NotesLog/NotesList';
import { NoteModal } from '../NotesLog/NoteModal';

const styles = StyleSheet.create({
  wrapper: {
    padding: '0 40px',
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 50,
    maxWidth: 600,
  },
});

export namespace NotesLog {
  export interface Props {
    roomId: string;
    notesLoading: boolean;
  }
}

export const NotesLog: React.FC<NotesLog.Props> = ({ roomId, notesLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div data-it={'NotesLog'}>
      <div className={css(styles.headerWrapper)}>
        <TabSectionHeader>Notes Log</TabSectionHeader>
        <ActionButton
          data-dd-privacy="allow"
          data-it="NotesLog-addNewNoteBtn"
          btnSize="md"
          label="Add New Note"
          onClick={() => setIsModalOpen(true)}
          type="button"
        />
        {isModalOpen && (
          <NoteModal
            data-it="NotesLog-addNewNoteModal"
            headerText="Add New Note"
            roomId={roomId}
            handleClose={() => setIsModalOpen(false)}
            subHeaderText="Warning: You cannot remove or update a note once saved."
          />
        )}
      </div>
      {!notesLoading && <NotesList />}
    </div>
  );
};
